module.exports = __webpack_public_path__ + "static/media/3.033ac13e.png";